import { Component, Inject, OnInit, Renderer2, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { COMMON_MODULES, ROUTES } from '@app/core/constants';
import { FeatherIconModule } from '@app/theme-core/feather-icon/feather-icon.module';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { filter } from 'rxjs';
import { HelperService, LocalStorageService, SharedDataService } from '@src/app/core/services';
import { WarningBlockComponent } from '@src/app/features/profile/core/warning-block/warning-block.component';
declare var $: any;

@Component({
  selector: 'app-navbar',
  standalone: true,
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  imports: [...COMMON_MODULES, FeatherIconModule, NgbDropdownModule, WarningBlockComponent],
})
export class NavbarComponent implements OnInit {
  public routes = ROUTES
  public user :any;
  localStorageService = inject(LocalStorageService)
  sharedService = inject(SharedDataService)
  isUser : boolean = false
  isLoginPage: boolean = false;
  isRegisterPage: boolean = false;
  currentRoute: any = '';
  helperService = inject(HelperService)

  //Warning error variables
  showFutureServiceErr = false;
  errMsg = 'some msg';
  containerStyle = 'padding: 0';
  msgBodyStyle = 'border-radius: 0'

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
  ) {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: any) => {
        if (event instanceof NavigationEnd && this.currentRoute !== event.url) {
          this.currentRoute = event.url;
          this.shouldShowMenu(event.urlAfterRedirects || event.url);
        }
      });

    this.shouldShowMenu(window.location.href);
    // this.activatedRoute.

    this.sharedService.globalMembershipError.subscribe((data: any)=> {
       this.showFutureServiceErr = data.showErr;
       this.errMsg = data.msg;
    })
  }
  private shouldShowMenu(url: string): void {
    // Implement your logic to determine when to show/hide the menu based on the route
    // For example, you can check if the route is '/login' or '/dashboard'
    this.isUser = this.localStorageService.getDataInLocalStorage("token") ? true : false
    this.isLoginPage = url.includes('/login');
    this.isRegisterPage = url.includes('/register');
    if (url.includes('/forgot')) {
      this.isRegisterPage = url.includes('/forgot');
    }
  }
  ngOnInit(): void {
    $(document).on('click', '.navbar-toggler', function (e: any) {
      if ($('.navbar-toggler-icon-custom').hasClass('active')) {
        $('.navbar-toggler-icon-custom').removeClass('active');
      } else {
        $('.navbar-toggler-icon-custom').addClass('active');
      }
    });
    this.user = this.localStorageService.getDataInLocalStorage("user_information")
  }
  
  /**
   * Sidebar toggle on hamburger button click
   */
  toggleSidebar(e: Event) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }

  hideError(e: any) {
    this.showFutureServiceErr = false;
  }

  /**
   * Logout
   */
  onLogout(e: Event) {
    e.preventDefault();
    localStorage.removeItem('isLoggedin');

    if (!localStorage.getItem('isLoggedin')) {
      this.router.navigate(['/auth/login']);
    }
  }
  logout(){
    localStorage.clear()
    window.location.reload()
  }
}
